import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "flex-row" }
const _hoisted_3 = { class: "weapon-slot disabled" }
const _hoisted_4 = { class: "weapon-slot disabled" }
const _hoisted_5 = { class: "flex-row" }
const _hoisted_6 = { class: "gear-image-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "gear-text-container fix-right" }
const _hoisted_9 = { class: "gear-image-container" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "gear-text-container fix-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.equippedGear.w1?.name ?? "Weapon Slot 1 [DISABLED]"), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.equippedGear.w2?.name ?? "Weapon Slot 2 [DISABLED]"), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "head-slot",
        title: "Equip/unequip gear",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('equip', 'head')))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _ctx.getGearImage('head', _ctx.equippedGear.head?.image ?? 'VaultSuit'),
            alt: "",
            class: "gear-image fix-left"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", {
          class: "prefix-container fix-left-2",
          style: _normalizeStyle(`color: ${
            _ctx.getItemPrefixData(_ctx.equippedGear.headBonusStatsCount)?.color
          };`)
        }, _toDisplayString(_ctx.equippedGear.head?.prefix?.toUpperCase()), 5),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.equippedGear.head?.name ?? "No Helmet"), 1)
      ]),
      _createElementVNode("div", {
        class: "body-slot",
        title: "Equip/unequip gear",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('equip', 'body')))
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: _ctx.getGearImage('body', _ctx.equippedGear.body?.image ?? 'VaultSuit'),
            alt: "",
            class: "gear-image fix-right"
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("div", {
          class: "prefix-container fix-right-2",
          style: _normalizeStyle(`color: ${
            _ctx.getItemPrefixData(_ctx.equippedGear.bodyBonusStatsCount)?.color
          };`)
        }, _toDisplayString(_ctx.equippedGear.body?.prefix?.toUpperCase()), 5),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.equippedGear.body?.name ?? "Vault Suit"), 1)
      ])
    ])
  ]))
}